<template>
  <div class="recording_warp">
    <div class="content_wrap">
      <img class="bg" src="./../assets/img/jl.png" mode='scaleToFill' />
      <div class="content">
        <div class="user_info">
          <img class="avatar" :src="avatar" mode='widthFix'>
          <p class="name">{{name}}</p>
        </div>
        <ul class="list">
          <li class="top">
            <span>抽奖记录</span>
            <span>时间</span>
          </li>
          <li class="item" v-for="(item, index) in list" :key="index">
            <span>{{item.award_name}}</span>
            <span>{{item.created_at}}</span>
          </li>
        </ul>
        <div class="btn">
          <img @click="closeClick" src="./../assets/img/answer6.png" mode='widthFix'>
        </div>
      </div>
      <div class="dibu" @click="closeClick"></div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk'
export default {
  data() {
    return {
      list:[],
      avatar:'',
      name: ''
    };
  },
  props:{
 
  },
  mounted(){
    var _this = this;
    // wx.getUserInfo({
    //   success(res) {
    //     _this.name = res.userInfo.nickName;
    //     _this.avatar = res.userInfo.avatarUrl;
        
    //   }
    // });
    this.avatar = window.localStorage.getItem('avatar');
    this.name = window.localStorage.getItem('nickname');
    this.getData();
  },
  methods:{
    getData(){
      var access_token = window.localStorage.getItem('access_token');
      // this.$http.get(`${this.service}questionnaire/draw-record?access-token=${this.$store.state.access_token}`)
      this.$http.get(`${this.service}questionnaire/draw-record?access-token=` + access_token)
      .then(res=>{
        this.list = res
      })
    },
    closeClick(){
      this.$emit('closeClick')
    }
  }
}
</script>

<style lang="less" scoped>
.recording_warp{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, .84);
  z-index: 99;
  .content_wrap{
    width: 6.98rem;
    height: 10.03rem;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    // border-radius: 15rpx;
    overflow: hidden;
    padding: 3.05rem 1.09rem 0;
    box-sizing: border-box;
    .bg{
      width: 6.98rem;
      height: 10.03rem;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
    }
    .content{
      position: relative;
      .user_info{
        text-align: center;
        .avatar{
          width: 1.38rem;
          height: 1.38rem;
          border-radius: 100%;
        }
        .name{
          font-size: .32rem;
          color: #fff;
          margin-top: .12rem;
          font-weight: bold;
          text-shadow: .04rem .04rem .08rem rgba(218, 88, 88, .75);
        }
      }
      .list{
        margin-top: .15rem;
        border-radius: .15rem;
        background-color: #fff;
        padding: .15rem;
        li{
          line-height: .80rem;
          span{
            text-align: center;
            display: inline-block;
            width: 48%;
          }
        }
        .top{
          font-size: .28rem;
          color: #e03716;
          font-weight: bold;
          border-bottom:1px solid #a0a0a0;
          
        }
        .item{
          font-size: .28rem;
          color: #313131;
          // font-weight: bold;
        }
      }
      .btn{
        text-align: center;
        margin: .29rem auto 0;
        width: 1.70rem;
        height: .79rem;
        img{
          width: 1.70rem;
          height: .79rem;
        }
      }
    }
    .dibu {
      width: .74rem;
      height: .74rem;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/recording.vue